// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../atoms/Icon/IconV5.bs.js");
let Link = require("next/link").default;
let Next__Image = require("../../../../reason/next/Next__Image.bs.js");
let ReactRender = require("../../../../reason/utils/ReactRender.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function UIKit__VerticalCard(props) {
  let media = props.media;
  let tmp;
  if (media.TAG === "Image") {
    let match = media._0;
    tmp = JsxRuntime.jsx(Next__Image.make, {
      src: match.src,
      fill: true,
      unoptimized: true,
      alt: match.alt,
      className: "object-center object-cover"
    });
  } else {
    tmp = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(IconV5.make, {
        icon: media._0,
        size: 78,
        className: "text-zinc-500"
      }),
      "aria-hidden": true,
      className: TailwindMerge.twMerge([
        "absolute inset-0 bg-zinc-200 flex items-center justify-center",
        Stdlib_Option.getOr(props.iconContainerClassName, "")
      ])
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.children,
        className: "p-3 order-2 flex flex-col flex-1"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          ReactRender.fromOption(props.mediaLink, href => JsxRuntime.jsx(Link, {
            href: href,
            className: "absolute inset-0 z-20",
            "aria-hidden": true,
            tabIndex: -1
          })),
          tmp,
          ReactRender.fromOption(props.topLeftLabels, labels => JsxRuntime.jsx("div", {
            children: labels,
            className: "absolute top-2 left-2"
          })),
          ReactRender.fromOption(props.topRightLabels, labels => JsxRuntime.jsx("div", {
            children: labels,
            className: "absolute top-2 right-2"
          })),
          ReactRender.fromOption(props.mediaTextOverlay, text => JsxRuntime.jsx("div", {
            children: text,
            className: "flex bg-[#5a5a59bf] h-[30px] items-center py-0.5 px-4 text-white text-[13px] leading-[1.25] absolute left-0 right-0 bottom-0"
          }))
        ],
        className: "relative order-1 w-full flex-none min-h-0 aspect-[648/468]"
      })
    ],
    className: "bg-white flex h-full rounded-md overflow-hidden flex-col border border-gray-200 shadow-sm relative [will-change:box-shadow,transform] transition duration-150 ease-in hover:-translate-y-px hover:shadow-lg focus-within:z-20"
  });
}

let make = UIKit__VerticalCard;

exports.make = make;
/* IconV5 Not a pure module */
